import { Controller } from "@hotwired/stimulus";

// A small popover: the chat-history dropdown under the panel title, and the
// Skills menu in the composer. Closes on outside click and on Escape, because
// both live inside a drawer that is itself dismissible and a menu that outlives
// its trigger is the fastest way to make a panel feel broken.
export default class extends Controller {
  static targets = ["menu"];
  static values = { open: Boolean };

  connect() {
    this.onDocumentClick = (event) => {
      if (this.element.contains(event.target)) return;
      this.close();
    };
    this.onKeydown = (event) => {
      if (event.key === "Escape") this.close();
    };
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);

    // Re-rendered with the menu already up (a skill was toggled and the server
    // replaced this element). Without this the popover would blink shut on
    // every checkbox.
    if (this.openValue) this.open();
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  toggle(event) {
    event.preventDefault();
    if (this.element.classList.contains("kit-menu--open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.classList.add("kit-menu--open");
  }

  close() {
    this.element.classList.remove("kit-menu--open");
  }

  // Checkbox-driven forms: submit on change so a skill toggles with one click
  // rather than click-then-save.
  submitForm(event) {
    const form = event.target.closest("form");
    if (form) form.requestSubmit();
  }
}
